// extracted by mini-css-extract-plugin
module.exports = {"panel":"panel___383xQ","panel-heading":"panel-heading___NkAv8","panel-control":"panel-control___3r5pa","panel-body":"panel-body___2Bcf8","no-padding":"no-padding___13oyy"};